"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSiteFloorPlan = void 0;
const react_cirrus_store_1 = require("@yanzi/react-cirrus-store");
const react_oauth_1 = require("@yanzi/react-oauth");
const react_1 = require("react");
const react_query_1 = require("react-query");
const useSite_1 = require("./useSite");
function useSiteFloorPlan(floorLevel, options = {}) {
    const site = useSite_1.useSite();
    return useFloorPlan(`yanzi://${site.id.type === 'location'
        ? `location/${site.id.locationId}`
        : `account/${site.id.accountNumber}/prospects/${site.id.prospectId}`}/model`, floorLevel, options);
}
exports.useSiteFloorPlan = useSiteFloorPlan;
function useFloorPlan(baseUrl, floorLevel, { skip = false } = {}) {
    var _a;
    const manifestUrl = `${baseUrl}/manifest.json`;
    const { data: manifest } = react_cirrus_store_1.useCirrusStoreGet(manifestUrl, 'application/json', { skip });
    const rotation = (_a = manifest === null || manifest === void 0 ? void 0 : manifest.mapRotation) !== null && _a !== void 0 ? _a : undefined;
    const geoJsonLayers = react_1.useMemo(() => {
        var _a, _b;
        return ((_b = (_a = manifest === null || manifest === void 0 ? void 0 : manifest.layers) === null || _a === void 0 ? void 0 : _a.filter((layer) => `${layer.floorLevel}` === `${floorLevel}` &&
            layer.contentType === 'application/vnd.geo+json' &&
            typeof layer.src === 'string')) !== null && _b !== void 0 ? _b : []);
    }, [manifest, floorLevel]);
    const yanziModelLayers = react_1.useMemo(() => {
        var _a;
        return (_a = manifest === null || manifest === void 0 ? void 0 : manifest.layers) === null || _a === void 0 ? void 0 : _a.filter((layer) => `${layer.floorLevel}` === `${floorLevel}` &&
            layer.contentType === 'application/yanzi.model' &&
            'yanziModelId' in layer);
    }, [manifest, floorLevel]);
    const get = react_cirrus_store_1.useCirrusStoreGetFunction(`${baseUrl}/`, 'application/json');
    const { data: layerData } = react_query_1.useQuery(['model-layers', baseUrl, geoJsonLayers], () => Promise.all(geoJsonLayers.map(layer => get(layer.src))), { staleTime: 30 * 60 * 1000 });
    const { accessToken } = react_oauth_1.useOAuth();
    const { data: modelLayerData } = react_query_1.useQuery(['model-model-layers', yanziModelLayers], () => [], { staleTime: 2 * 60 * 1000, enabled: !!accessToken });
    const featureCollections = react_1.useMemo(() => {
        return [...(layerData !== null && layerData !== void 0 ? layerData : []), ...(modelLayerData !== null && modelLayerData !== void 0 ? modelLayerData : [])];
    }, [layerData, modelLayerData]);
    return {
        featureCollections,
        rotation,
    };
}
//# sourceMappingURL=useSiteFloorPlan.js.map